// Reálne čísla z produkcie (aktualizované 2026-07-23, zdroj: produkčná DB).
// Pri ďalšej aktualizácii stačí prepísať hodnoty.
const LIVE_SINCE = new Date('2025-06-29');

const monthsLive = Math.max(
  1,
  Math.floor((Date.now() - LIVE_SINCE.getTime()) / (1000 * 60 * 60 * 24 * 30.44))
);

export const LIVE_STATS = [
  { value: 3469, suffix: '', labelKey: 'stats.shifts' },
  { value: 32680, suffix: '', labelKey: 'stats.hours' },
  { value: monthsLive, suffix: '', labelKey: 'stats.months' },
];
